import { Alert } from "@altimateai/lego";
import { Stack } from "@altimateai/lego";
import { CommonIntegrationInstance } from "./mcpSlice";
import CustomIntegration from "./CustomIntegration";
import { RelativeComponentLoader } from "@/components/loader";
import useCustomIntegrations from "./useCustomIntegrations";

interface Props {
  onEditOpen: (instance: CommonIntegrationInstance) => void;
}

const CustomIntegrationsSelector = ({ onEditOpen }: Props) => {
  const {
    customIntegrations,
    isLoadingCustomIntegrations,
    isCustomIntegrationsError,
    showCustomIntegrationsEmpty,
    showCustomIntegrationsData,
  } = useCustomIntegrations({ shouldRefetchOnWindowFocus: false });

  if (isLoadingCustomIntegrations) {
    return <RelativeComponentLoader label="Loading Custom Integrations..." />;
  }

  return (
    <div>
      {isLoadingCustomIntegrations && (
        <RelativeComponentLoader label={`Loading Custom Integrations...`} />
      )}
      {!isLoadingCustomIntegrations && isCustomIntegrationsError && (
        <Alert className="al-border-0 al-bg-bg-red al-text-gray">
          Error fetching custom integrations
        </Alert>
      )}
      {showCustomIntegrationsEmpty && (
        <Stack
          justify="center"
          direction="column"
          gap="lg"
          align="center"
          className="al-p-8 al-border al-rounded m-4"
        >
          <p className="al-text-2xl">No Custom Integrations</p>
          <p className="al-text-sm al-text-muted-foreground">
            Your custom integrations will show up here after you add one.
          </p>
        </Stack>
      )}
      {showCustomIntegrationsData && (
        <Stack direction="column" className="al-gap-6 al-mb-8">
          <Stack direction="row" wrap className="al-gap-4">
            {customIntegrations?.items.map(instance => (
              <CustomIntegration key={instance.id} instance={instance} onEditOpen={onEditOpen} />
            ))}
          </Stack>
        </Stack>
      )}
    </div>
  );
};

export default CustomIntegrationsSelector;
